// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"5a3db5ed","6850":"307c0710"}[chunkId] + ".chunk.css";
};